import { render } from "./UserPasswordSettings.vue?vue&type=template&id=31924e39"
import script from "./UserPasswordSettings.vue?vue&type=script&lang=js"
export * from "./UserPasswordSettings.vue?vue&type=script&lang=js"

import "./UserPasswordSettings.vue?vue&type=style&index=0&id=31924e39&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__